import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import App from './components/App';
import './assets/index.css';
import './assets/main.css';
import './assets/tailwind.generated.css';

ReactDOM.render(
  <Router>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </Router>,
  document.getElementById('root')
);
